import React, { Component } from 'react';
import CheckDefecto from '../../../../../Common/Components/CheckDefecto';
import SelectWithLabel from '../../../../../Common/Components/SelectWithLabel';

class NombreFinal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { data, archivoAsociado } = this.props;
        const { proceso } = data;

        let rbConGuion, rbSinGuion, rbSoloFechaConGuion, rbSoloHoraConGuion;
        let optionOrdenNombreArchivo = [];
        let extension = data?.proceso?.Extension;

        let muestraSelectNombreArchivo = (!archivoAsociado?.formatoOrdenArchivoCombo || !archivoAsociado?.formatoOrdenArchivoCombo == "0")
            && !archivoAsociado.checkFecha && !archivoAsociado.checkHora ? false : true;

        let muestraSepararFechaHoraRb = (!archivoAsociado?.checkHora || !archivoAsociado.checkFecha)
            ? false : true;

        let muestraLosRb = (!archivoAsociado?.checkHora && !archivoAsociado.checkFecha)
            ? false : true;

        if (archivoAsociado?.optionNombreArchivo && archivoAsociado.optionNombreArchivo.length > 0) {
            optionOrdenNombreArchivo = archivoAsociado.optionNombreArchivo.map((nomArchivo, index) => {
                return (
                    <option value={nomArchivo.Id} key={"nomArchivo-option-" + index} data-codigo={nomArchivo.Id}>
                        {nomArchivo.Descripcion}
                    </option>
                );
            });
        }

        switch (archivoAsociado.idRBFormato) {
            case (1):
                rbConGuion = true;
                rbSinGuion = false;
                rbSoloFechaConGuion = false;
                rbSoloHoraConGuion = false;
                break;
            case (2):
                rbSinGuion = true;
                rbConGuion = false;
                rbSoloFechaConGuion = false;
                rbSoloHoraConGuion = false;
                break;
            case (3):
                rbSoloFechaConGuion = true
                rbSinGuion = false;
                rbConGuion = false;
                rbSoloHoraConGuion = false;
                break;
            case (4):
                rbSoloHoraConGuion = true;
                rbSoloFechaConGuion = false;
                rbSinGuion = false;
                rbConGuion = false;
                break;
            default:
                break;
        }

        return (
            <div className='row top-separator-xs'>
                {muestraSelectNombreArchivo && <div className="width400px marignLeft-15px">
                    <SelectWithLabel
                        options={optionOrdenNombreArchivo}
                        seleccionarCombo={this.props.setOptionFormatoArchivo}
                        value={archivoAsociado?.formatoOrdenArchivoCombo}
                        nombreCombo="formatoOrdenArchivoCombo"
                        titulo={archivoAsociado.labelNombreArchivo}
                        mensajeError={archivoAsociado.errorComboNombreArchivo ? "Seleccione una opción" : null}
                    />
                </div>}
                {muestraLosRb &&
                    <div>
                        <div className="row row-radio paddingLeft5px">
                            <div className="col-xs-4 top-separator-xs marignLeft-15px">
                                <div className="row row-radio">
                                    <div style={{ marginLeft: "4px" }} className="col-xs-12">
                                        <div className="container-radio radio-margin">
                                            <input id={"rbNombreArchivo" + 1}
                                                type="radio"
                                                name="rbNombreArchivo"
                                                value={1}
                                                checked={!archivoAsociado.idRBFormato ? this.props.setRadioButton(1) : rbConGuion}
                                                onChange={(event) => this.props.setRadioButton(1)} />
                                            <label
                                                className="lbl-radio label-secondary"
                                                htmlFor={"rbNombreArchivo" + 1}>
                                                Con guiones de separación
                                                <label className="label-secondary label-informativo"
                                                    htmlFor={"rbNombreArchivo" + 1}>
                                                    ej: nombrearchivo_20221016_1805
                                                </label>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="row row-radio">
                                    <div style={{ marginLeft: "4px" }} className="col-xs-12">
                                        <div className="container-radio radio-margin">
                                            <input id={"rbNombreArchivo" + 2}
                                                type="radio"
                                                name="rbNombreArchivo"
                                                value={2}
                                                checked={rbSinGuion}
                                                onChange={(event) => this.props.setRadioButton(2)} />
                                            <label
                                                className="lbl-radio label-secondary"
                                                htmlFor={"rbNombreArchivo" + 2}>
                                                Sin guiones de separación
                                                <label className="label-secondary label-informativo"
                                                    htmlFor={"rbNombreArchivo" + 2}>
                                                    ej: nombrearchivo202210161805
                                                </label>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                {muestraSepararFechaHoraRb &&
                                    <div>
                                        <div className="row row-radio">
                                            <div style={{ marginLeft: "4px" }} className="col-xs-12">
                                                <div className="container-radio radio-margin">
                                                    <input id={"rbNombreArchivo" + 3}
                                                        type="radio"
                                                        name="rbNombreArchivo"
                                                        value={3}
                                                        checked={rbSoloFechaConGuion}
                                                        onChange={(event) => this.props.setRadioButton(3)} />
                                                    <label
                                                        className="lbl-radio label-secondary"
                                                        htmlFor={"rbNombreArchivo" + 3}>
                                                        Separar sólo la fecha con guión
                                                        <label className="label-secondary label-informativo"
                                                            htmlFor={"rbNombreArchivo" + 3}>
                                                            ej: nombrearchivo_202210161805
                                                        </label>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row row-radio">
                                            <div style={{ marginLeft: "4px" }} className="col-xs-12">
                                                <div className="container-radio radio-margin">
                                                    <input id={"rbNombreArchivo" + 4}
                                                        type="radio"
                                                        name="rbNombreArchivo"
                                                        value={4}
                                                        checked={rbSoloHoraConGuion}
                                                        onChange={(event) => this.props.setRadioButton(4)} />
                                                    <label
                                                        className="lbl-radio label-secondary"
                                                        htmlFor={"rbNombreArchivo" + 4}>
                                                        Separar sólo la hora con guión
                                                        <label className="label-secondary label-informativo"
                                                            htmlFor={"rbNombreArchivo" + 4}>
                                                            ej: nombrearchivo20221016_1805
                                                        </label>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>}

                <div className="form-group top-separator-xs bottom-separator-xs marignLeft-15px">
                    <div className="col-md-12 no-padding-left">
                        <label className="label-secondary">{archivoAsociado.nombreFinal}{extension}</label>
                    </div>
                </div>
            </div>
        )
    };
}

export default NombreFinal;
